import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import logo from "../assets/img/logo.jpg";
import { FaAngleDown } from "react-icons/fa";

function Navbar() {
  const [showMega, setShowMega] = useState(false);
  const closeMega = () => setShowMega(false);


  return (
    <header className="nav-bar">
      <div className="">
     <nav
  className="navbar navbar-expand-lg navbar-light bg-white py-2 px-4"
  style={{
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 2px 8px",
    zIndex: 9999,
    justifyContent: "space-between",
  }}
>
  {/* Logo */}
  <Link to="/" className="navbar-brand d-flex align-items-center">
    <img
      src={logo}
      alt="Videlicet Law"
      width="100"
      height="60"
      className="me-2"
    />
  </Link>

  {/* Mobile Toggle */}
  <button
    type="button"
    className="navbar-toggler"
    data-bs-toggle="collapse"
    data-bs-target="#navbarCollapse"
    aria-controls="navbarCollapse"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span className="navbar-toggler-icon"></span>
  </button>

  {/* Collapse Wrapper */}
  <div className="collapse navbar-collapse justify-content-end" id="navbarCollapse">
    <ul className="navbar-nav align-items-center">
      <li className="nav-item">
        <NavLink to="/home" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
          Home
        </NavLink>
      </li>

      <li className="nav-item">
        <NavLink to="/about" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
          About
        </NavLink>
      </li>

      <li className="nav-item">
        <NavLink to="/ourteam" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
          Our Team
        </NavLink>
      </li>

    <li className="nav-item position-static">
  <div
    className="mega-hover-wrapper"
    onMouseEnter={() => setShowMega(true)}
    onMouseLeave={() => setShowMega(false)}
  >
<NavLink
  to="/team"
  className={({ isActive }) =>
    "nav-link d-flex align-items-center gap-1" +
    (isActive ? " active" : "")
  }
  onClick={(e) => {
    e.preventDefault();
    setShowMega(prev => !prev);
  }}
>
  Practice Areas

  <FaAngleDown
    className={`mega-toggle-icon ${showMega ? "rotate" : ""}`}
  />
</NavLink>

    {showMega && (
      <div className="mega-menu-custom">
        <div className="container-fluid">
          <div className="row px-4">

            {/* LEFT */}
            <div className="col-lg-3 mega-left pe-5">
              <h6>Practice Areas</h6>
              <ul>
                <li className="active">
                  <NavLink to="/submenu" onClick={closeMega}>
                    Real Estate
                  </NavLink>
                </li>
                <li className="text-white">
                  <NavLink to="/litigation" onClick={closeMega} className="text-white">
                   Redevelopment & Self-Redevelopment
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* COLUMN 1 */}
            <div className="col-lg-3 ps-lg-5">
              <h6>Practice Area 1</h6>
              <ul>
                <li><NavLink to="/submenu" onClick={closeMega}>Nature Of Work </NavLink></li>
                <li><NavLink to="/Litigation" onClick={closeMega}>Redevelopment & Self-Redevelopment Consultancy</NavLink></li>
                <li><NavLink to="/practice-areas/ip-assignments" onClick={closeMega}>Submenu 3</NavLink></li>
                <li><NavLink to="/practice-areas/cyber-security" onClick={closeMega}>Submenu 4</NavLink></li>
              </ul>
            </div>

            {/* COLUMN 2 */}
            <div className="col-lg-3">
              <h6>Practice Area 2</h6>
              <ul>
                <li><NavLink to="/practice-areas/data-protection" onClick={closeMega}>Submenu 1</NavLink></li>
                <li><NavLink to="/practice-areas/licensing" onClick={closeMega}>Submenu 2</NavLink></li>
                <li><NavLink to="/practice-areas/advertising" onClick={closeMega}>Submenu 3</NavLink></li>
                <li><NavLink to="/practice-areas/sports-law" onClick={closeMega}>Submenu 4</NavLink></li>
              </ul>
            </div>

            {/* COLUMN 3 */}
            <div className="col-lg-3">
              <h6>Practice Area 3</h6>
              <ul>
                <li><NavLink to="/practice-areas/ip-litigation" onClick={closeMega}>Submenu 1</NavLink></li>
                <li><NavLink to="/practice-areas/technology-transfer" onClick={closeMega}>Submenu 2</NavLink></li>
                <li><NavLink to="/practice-areas/ecommerce-law" onClick={closeMega}>Submenu 3</NavLink></li>
                <li><NavLink to="/practice-areas/healthcare-law" onClick={closeMega}>Submenu 4 </NavLink></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    )}
  </div>
</li>

<li className="nav-item dropdown">
  <NavLink
    to="/publications"
    className={({ isActive }) =>
      "nav-link dropdown-toggle d-flex align-items-center gap-1" +
      (isActive ? " active" : "")
    }
  >
    Media
    
  </NavLink>

  {/* <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/publications"
        className={({ isActive }) =>
          "dropdown-item" + (isActive ? " active" : "")
        }
      >
        Articles & Publications
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/blogs"
        className={({ isActive }) =>
          "dropdown-item" + (isActive ? " active" : "")
        }
      >
        Blogs
      </NavLink>
    </li>
  </ul>*/}
</li> 

      <li className="nav-item">
        <NavLink to="/video" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
          Videos
        </NavLink>
      </li>

      <li className="nav-item">
        <NavLink to="/contact" className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}>
          Contact
        </NavLink>
      </li>
    </ul>
  </div>
</nav>

      </div>
    </header>
  );
}

export default Navbar;
